import React from "react"
import { DckActionCreators, DckSelectors } from "dck-redux"
import * as ItemTypes from "../../../../redux/items/types"
import { connect } from "react-redux"
import PropTypes from "prop-types"

class ManageInvestorPayment extends React.Component {

  componentDidMount() {
    const { params: { id }, setCurrentId, reloadInvestorPayment } = this.props
    setCurrentId(id)
    reloadInvestorPayment(id)
  }

  render() {
    const { investorPayment, callback, setInvestorPayment, removeInvestorPayment } = this.props
    return investorPayment
      ? callback(investorPayment, setInvestorPayment, removeInvestorPayment) 
      : <p>Loading ..</p>
  }
}

ManageInvestorPayment.propTypes = {
  investorPayment: PropTypes.object,
  setCurrentId: PropTypes.func.isRequired,
  params: PropTypes.object.isRequired
}

const mapStateToProps = (state, ownProps) => {

  const investorPayment = DckSelectors.selectItemById(
    state,
    ItemTypes.InvestorPayment, ownProps.params.id
  )
  return { investorPayment }
},

mapDispatchToProps = dispatch => ({

  setCurrentId: id => dispatch(DckActionCreators.itemMakeActive(ItemTypes.InvestorPayment, id)),

  setInvestorPayment: (id, data) => dispatch(DckActionCreators.itemSet(ItemTypes.InvestorPayment, id, data)),

  reloadInvestorPayment: id => dispatch(DckActionCreators.itemReload(ItemTypes.InvestorPayment, id)),

  removeInvestorPayment: id => dispatch(DckActionCreators.itemRemove(ItemTypes.InvestorPayment, id)),
})

export default connect(mapStateToProps, mapDispatchToProps)(ManageInvestorPayment)



// WEBPACK FOOTER //
// ./src/components/Financiers/Investors/Payments/ManageItem.js